import { Route } from '@angular/router';
import { AuthGuard } from './../core/auth.guard';
import { ComplianceCentralComponent } from './views/compliance-central/compliance-central.component';
import { V2Component } from './v2.component';
import { EntityDirectoryComponent } from './views/entity-directory/entity-directory.component';
import { GlobalGuideComponent } from './views/global-guide/global-guide.component';

import { prefix } from './constants';
import { EntityDetailComponent } from './views/entity-directory/components/detail/detail.component';

export const Routes: Route[] = [{
  canActivate: [AuthGuard],
  component: V2Component,
  path: prefix,
  children: [{
    component: ComplianceCentralComponent,
    path: 'compliance'
  }, {
    component: EntityDirectoryComponent,
    path: 'entity-directory'
  }, {
    component: GlobalGuideComponent,
    path: 'global-guide'
  }, {
    path: 'global-guide/:id',
    component: GlobalGuideComponent
  }, {
    children: [{
      path: 'dashboard',
      component: EntityDetailComponent
    }, {
      path: 'repository',
      component: EntityDetailComponent
    }, {
      path: 'transactions',
      component: EntityDetailComponent
    }],
    component: EntityDetailComponent,
    path: 'entity/:id'
  }, {
    path: '**',
    redirectTo: prefix
  }]
}];
